/**
 * What the rate card can actually price.
 *
 * These mirror the product_rate_tier rows: the lowest tier starts at R3,000 and the highest runs
 * to R999,999,999. An amount outside that range has no tier, and the pricing call fails rather
 * than returning a rate -- so the capture screens refuse it up front instead of letting it through
 * to surface as a server error at credit assessment.
 *
 * SEDFA is a product rule rather than a rate-card one, which is why it keeps its own lower ceiling.
 */

export const MIN_LOAN_AMOUNT = 3000;

/** Ceiling of the highest product rate tier. */
export const MAX_LOAN_AMOUNT = 999999999;

export const SEDFA_MAX_LOAN_AMOUNT = 250000;

export const maxLoanAmountFor = (isSedfaLoan: boolean): number =>
  isSedfaLoan ? SEDFA_MAX_LOAN_AMOUNT : MAX_LOAN_AMOUNT;
